import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Hero.css";

const Hero = () => {
  const [feet, setFeet] = useState("");
  const [inches, setInches] = useState("");
  const [weight, setWeight] = useState("");
  const [gender, setGender] = useState(""); // Add gender state
  const [bmi, setBmi] = useState(null);
  const [category, setCategory] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (feet && inches && weight) {
      const ft = parseFloat(feet);
      const inch = parseFloat(inches);
      const kg = parseFloat(weight);

      if (isNaN(ft) || isNaN(inch) || isNaN(kg)) return;

      const totalInches = (ft * 12) + inch;
      const heightMeters = totalInches * 0.0254;

      const bmiValue = (kg / (heightMeters * heightMeters)).toFixed(1);
      setBmi(bmiValue);

      if (bmiValue < 18.5) {
        setCategory("Underweight");
      } else if (bmiValue >= 18.5 && bmiValue <= 24.9) {
        setCategory("Normal");
      } else {
        setCategory("Overweight");
      }
    } else {
      setBmi(null);
      setCategory("");
    }
  }, [feet, inches, weight]);

  const getProgressWidth = () => {
    if (category === "Underweight") return "30%";
    if (category === "Normal") return "60%";
    if (category === "Overweight") return "100%";
    return "0%";
  };

  const handleDietPlanClick = () => {
    navigate(`/diet-plan?category=${category.toLowerCase()}&gender=${gender.toLowerCase()}`);
  };

  return (
    <section className="hero-section">
      <div className="container">
        <div className="row justify-content-center align-items-center min-vh-100">
          <div className="col-lg-8 col-md-8 col-12 text-center">
            <h1 className="hero-title">Calculate Your BMI & Get Best Diet Plan!</h1>
            <p className="hero-subtitle">
              Track your health with our easy-to-use calculator
            </p>
            <form className="bmi-form text-center mx-auto" onSubmit={(e) => e.preventDefault()}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <input
                    type="number"
                    name="feet"
                    value={feet}
                    onChange={(e) => setFeet(e.target.value)}
                    className="form-control"
                    placeholder="Height (Feet)"
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="number"
                    name="inches"
                    value={inches}
                    onChange={(e) => setInches(e.target.value)}
                    className="form-control"
                    placeholder="Height (Inches)"
                    required
                  />
                </div>
              </div>
              <div className="mb-3">
                <select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                  className="form-control"
                  required
                >
                  <option value="" disabled>Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div className="mb-3">
                <input
                  type="number"
                  name="weight"
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    className="form-control"
                    placeholder="Weight (kg)"
                    required
                  />
                </div>
              </form>

              {bmi && (
                <div className="bmi-result">
                  <h3>Your BMI: <span>{bmi}</span></h3>
                  <div className="progress">
                    <div
                      className={`progress-bar ${category.toLowerCase()}`}
                      role="progressbar"
                      style={{ width: getProgressWidth() }}
                    ></div>
                  </div>
                  <p className="bmi-category">You are <b>{category}</b></p>
                  <p className="bmi-suggestion">
                    Based on your BMI, we recommend a customized plan to help you reach your health goals.
                  </p>
                  <button 
                    className="btn diet-plan-btn"
                    onClick={handleDietPlanClick}
                    disabled={!gender} // Disable button if gender not selected
                  >
                    View Our Custom Diet Plan
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  };

  export default Hero;